document.addEventListener('DOMContentLoaded', function() {
  console.log('🔥 Bundle Variant Switcher Loaded');

  const bundleOptions = document.querySelectorAll('.bundle-selector__option');

  if (!bundleOptions.length) {
    console.warn('⚠️ No bundle options found.');
    return;
  }

  bundleOptions.forEach(option => {
    option.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      const variantPrice = this.getAttribute('data-variant-price');
      const variantCompareAtPrice = this.getAttribute('data-variant-compare-at-price');

      if (!variantId) {
        console.error('❌ No variant ID found on button');
        return;
      }

      // STEP 1: Update the hidden variant input
      const variantInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        console.log(`👉 Switched variant to ID: ${variantId}`);
      } else {
        console.error('❌ Could not find variant input field.');
      }

      // STEP 2: Update form action (optional)
      const productForm = document.querySelector('form[action^="/cart/add"]');
      if (productForm) {
        productForm.setAttribute('action', `/cart/add?id=${variantId}`);
      }

      // STEP 3: Update browser URL without reload
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', newUrl);

      // STEP 4: Highlight selected button
      bundleOptions.forEach(btn => btn.classList.remove('selected'));
      this.classList.add('selected');

      // STEP 5: Update displayed price
      const priceElement = document.querySelector('[data-product-price]');
      const compareAtPriceElement = document.querySelector('[data-compare-at-price]');

      if (priceElement && variantPrice) {
        priceElement.innerText = variantPrice;
      }
      if (compareAtPriceElement) {
        if (variantCompareAtPrice && variantCompareAtPrice !== variantPrice) {
          compareAtPriceElement.innerText = variantCompareAtPrice;
          compareAtPriceElement.style.display = 'inline';
        } else {
          compareAtPriceElement.style.display = 'none';
        }
      }
    });
  });
});
